
import * as types from '../mutation-types'

//
export const state = {
    alert : {
        show: false
    }
}

//
export const mutations = {

    [types.SET_ALERT] (state,  alert ){
      state.alert = alert
    }
}


//
export const actions = {

  // metodo root da alert
  showAlert( {commit} , msg){

      let alert = {
            show: true,
            type: msg.type,
            title: msg.title,
            message: msg.message,
            duration: 4000
          }

      commit(types.SET_ALERT, alert)

      setTimeout(()=>{
         alert = { show : false}
         commit(types.SET_ALERT, alert)
      },4000)

  },

  closeAlert({commit}){
      let alert = {show : false}
      commit(types.SET_ALERT, alert)
  },

  // mensagem salvar
  salvoComSucesso({dispatch}, nome){

    dispatch('showAlert', {
              type:'success',
              title:'Muito Bem',
              message: `${nome} Salvo(a) com sucesso!`
          })

  },

  // mensagem editar
  editadoComSucesso({dispatch}, nome){

    dispatch('showAlert', {
              type:'success',
              title:'Muito Bem',
              message: `${nome} Editado(a) com sucesso!`
          })

  },

  // mensagem cadastrar
  cadastradoComSucesso({dispatch}, nome){

      dispatch('showAlert', {
              type:'success',
              title:'Muito Bem',
              message: `${nome} Cadastrado(a) com sucesso!`
          })
  },

  // mensagem erro ao salvar
  erroAoSalvar({dispatch}){

      dispatch('showAlert', {
              type:'danger',
              title:'Ops, não salvou...',
              message:'Atualize esta página para tentar novamente.'
          })
  },

  // mensagem erro ao cadastrar
  erroAoCadastrar({dispatch}){

      dispatch('showAlert', {
              type:'danger',
              title:'Ops, não cadastou...',
              message:'Atualize esta página para tentar novamente.'
          })
  },

  // mensagem erro ao carregar dados
  erroAoCarregar({dispatch}, msg){

      dispatch('showAlert', {
              type:'danger',
              title:`Ops, não carregou ${msg}.`,
              message:'Atualize esta página para tentar carregar novamente.'
          })
  },

  // mensagem erro ao carregar dados
  formularioIncompleto({dispatch}, msg){

      dispatch('showAlert', {
              type:'warning',
              title:`Ops, ${msg}`,
              message:'Verifique os dados no formulário.'
          })
  }

}










//



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/alert.js